const hasOwn = (value, key) => {
    return !!value && Object.prototype.hasOwnProperty.call(value, key)
}

const normalizedStatus = (value) => {
    return String(value || '').trim().toLowerCase().replace(/[\s-]+/g, '_')
}

export const hasPartAvailability = (part) => {
    return hasOwn(part, 'available')
        || hasOwn(part, 'availabilityStatus')
        || hasOwn(part, 'is_available')
        || hasOwn(part, 'availability_status')
}

export const isPartAvailable = (part) => {
    if(!part){
        return false
    }
    if(hasOwn(part, 'available')){
        return part.available === true
    }
    if(hasOwn(part, 'availabilityStatus')){
        return normalizedStatus(part.availabilityStatus) === 'available'
    }
    if(hasOwn(part, 'is_available')){
        return part.is_available === true || Number(part.is_available) === 1
    }
    if(hasOwn(part, 'availability_status')){
        return normalizedStatus(part.availability_status) === 'available'
    }

    // Selection is fail-closed: catalog rows without an explicit availability
    // signal must not be offered as new Builder choices.
    return false
}

export const isPartUnavailable = (part) => {
    // Older saved builds have no availability snapshot. Preserve them without
    // inventing a warning until the API explicitly provides one.
    return hasPartAvailability(part) && !isPartAvailable(part)
}

export const hasUnavailableParts = (value) => {
    const parts = Array.isArray(value) ? value : [value]
    return parts.some((part) => isPartUnavailable(part))
}
